module.exports = "<div class=\"error\">\n\t<div class=\"content\">\n\t\t<h1>ERROR</h1>\n\t</div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/error/error.component.html
// module id = 1664
// module chunks = 0